<template>
    <BaseContainer class="dnnCloud-applyTrial-box" :loading="listLoading" :isHasPageFt="!listLoading">
    <template v-slot:hd>
       <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="souchs" @submit.native.prevent>
          <!-- <el-select v-model="value" placeholder="请选择" @change="changeSouch"  style="width:120px;">
            <el-option v-for="item in options" :key="item.value"  
              :label="item.label" :value="item.value">
            </el-option>
          </el-select> -->
          <el-form-item>
              <el-input  v-model="searchText"  placeholder="姓名 / 电话 / 公司" style="width:200px;"  @keyup.enter.native="getProList(1)"></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-input  v-model="proName" style="width:200px;"  @keyup.enter.native="getProList(1)"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" size="medium" v-on:click="getProList(1)">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- <el-tag :key="tag" v-for="tag in dynamicTags" closable 
          :disable-transitions="false" @close="handleClose(tag)"> 
            {{tag}} 
        </el-tag>
        <el-button v-if="dynamicTags!=''" class="button-new-tag" size="small" @click="delTags">清除标签</el-button> -->
      </el-col>
    </template>

    <template v-slot:main>
       <!--列表 :row-class-name="tableRowClassName"-->
      <el-table :data="proList" highlight-current-row  @selection-change="selsChange"  :height="maxTbHeight"
        style="width: 100%;" :header-cell-style="getRowClass" @sort-change="handleSortChange"
        >
        <el-table-column type="index" :index="indexMethod" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="usename" label="姓名" width="100" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="phone" label="电话" width="120" sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="qq" label="QQ" width="120" sortable="custom"  show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="company" label="公司" min-width="300"  sortable="custom" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="bumenzhiwei" label="部门职位" min-width="150" sortable="custom"  show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="adress" label="地址" min-width="300" sortable="custom"  show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="statusname" label="处理状态" width="120" sortable="custom"  show-overflow-tooltip>
            <template slot-scope="scope">
                <span class="myTag" :class="scope.row.status == '1'? 'success': 'warning' " > {{ scope.row.statusname }} </span>
            </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right"  min-width="120" style="text-algin:center">
          <template slot-scope="scope">
             <span class="operate">
                <el-tooltip effect="dark" content="详情" placement="top" >
                  <span class="dnnfont iconfile-search"  @click="handleView(scope.$index, scope.row)"></span>
                </el-tooltip>
               
                 <el-tooltip effect="dark" content="处理" placement="top">
                    <span class="dnnfont iconfile-done icon-disabled" v-if="scope.row.status !='0'"></span>
                    <span class="dnnfont iconfile-done"  v-else  @click="handleEdit(scope.$index, scope.row)"></span>
                </el-tooltip>
              </span>

            <!-- <el-button type="primary" plain size="small" @click="handleView(scope.$index, scope.row)">详情</el-button>
            <el-button :disabled="scope.row.status !='0'" type="success" plain size="small" @click="handleEdit(scope.$index, scope.row)">处理</el-button> -->
          </template>
        </el-table-column>
      </el-table>

       <!--详情界面-->
      <el-dialog class="model-edit" title="详情" :visible.sync="viewVisible" 
        :close-on-click-modal="false">
        <el-form :model="viewForm" label-width="80px"  ref="viewForm" @submit.native.prevent>
          <el-row>
            <el-col :span="12"> 
              <el-form-item label="姓名:" prop="usename">
               {{viewForm.usename}}
              </el-form-item>
            </el-col>
            <el-col :span="12"> 
              <el-form-item label="QQ:" prop="qq">
                {{viewForm.qq}}
              </el-form-item>
            </el-col>
            <el-col :span="12"> 
              <el-form-item label="电话:" prop="phone">
                {{viewForm.phone}}
              </el-form-item>
            </el-col>
            <el-col :span="12"> 
              <el-form-item label="部门职位:" prop="bumenzhiwei">
                {{viewForm.bumenzhiwei}}
              </el-form-item>
            </el-col>
            <el-col :span="22"> 
              <el-form-item label="公司:" prop="company">
                {{viewForm.company}}
              </el-form-item>
            </el-col>
            
            <el-col :span="22"> 
              <el-form-item label="地址:" prop="adress">
                {{viewForm.adress}}
              </el-form-item>
            </el-col>

          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:center">
          <el-button @click.native="viewVisible = false">确定</el-button>
        </div>
      </el-dialog>

    </template>

    <template v-slot:ft>
       <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination 
          layout="sizes, prev, pager, next"
          :page-sizes="[10, 20, 30, 50,100]"
          :current-page="pageNumber" 
          :page-size="pageSize" 
          :total="total" 
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          style="float:right;">
        </el-pagination>
      </el-col>
    </template>
  </BaseContainer>
</template>
<script>
import { API__code, API_trial } from '../../../api/index.js'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  data(){
    return{
      viewForm:{
        usename:'',
        phone:'',
        qq:'',
        company:'',
        adress:'',
        bumenzhiwei:'',
      },
      viewVisible:false,
      value:'',
      dynamicTags: [],
      options: [
        {value: '姓名',label: '姓名'}, 
        {value: '电话',label: '电话'},
        {value: 'QQ',label: 'QQ'},
        {value: '公司',label: '公司'},
        {value: '部门职位',label: '部门职位'},
        {value: '地址',label: '地址'},
      ],
      souchs:{},
      proName:'',

      proList:[],
      token:'',
      checkCode:'',
      id:'',
      listLoading:false,
      pageNumber:1,
      total:0,
      pageSize: 20,
      orderType:"",
      orderStr:'',

      searchText: '',

    }
  },

  components: {
    BaseContainer
  },
  methods:{
    tableRowClassName({row, rowIndex}) {
      
      if(row.status == '1'){
        return 'warning-row';
      }
      // if (rowIndex === 1) {
      //   return 'warning-row';
      // } else if (rowIndex === 3) {
      //   return 'success-row';
      // }
      return '';
    },
    handleClose(tag) {
      if(tag == "姓名"){
        this.souchs.usename = '';
        if(this.value == "姓名"){
          this.proName = '';
        }
      }
      if(tag == "电话"){
        this.souchs.phone = '';
        if(this.value == "电话"){
          this.proName = '';
        }
      }
      if(tag == "QQ"){
        this.souchs.qq = '';
        if(this.value == "QQ"){
          this.proName = '';
        }
      }
      if(tag == "公司"){
        this.souchs.company = '';
        if(this.value == "公司"){
          this.proName = '';
        }
      }
      if(tag == "部门职位"){
        this.souchs.bumenzhiwei = '';
        if(this.value == "部门职位"){
          this.proName = '';
        }
      }
      if(tag == "地址"){
        this.souchs.adress = '';
        if(this.value == "地址"){
          this.proName = '';
        }
      }
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    delTags:function(){
      this.souchs = {},
      this.value = '';
      this.proName = '';
      this.dynamicTags = [];
      this.pageNumber = 1;
      this.getProList(1);
    },
    changeSouch:function(val){
      if(val == "姓名"){
        this.proName = this.souchs.usename;
      }else if(val == "电话"){
        this.proName = this.souchs.phone;
      }else if(val == "QQ"){
        this.proName = this.souchs.qq;
      }else if(val == "公司"){
        this.proName = this.souchs.company;
      }else if(val == "部门职位"){
        this.proName = this.souchs.bumenzhiwei;
      }else if(val == "地址"){
        this.proName = this.souchs.adress;
      }
    },

    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex == 0) {
          return "background:#F5F7FA";
      } else {
          return "";
      }
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    handleSortChange:function(val){
      if(val){
        if(val.prop == "usename"){
          this.orderStr = "namepx";
        }else if(val.prop == "phone"){
          this.orderStr = "phonepx";
        }else if(val.prop == "qq"){
          this.orderStr = "qqpx";
        }else if(val.prop == "company"){
          this.orderStr = "companypx";
        }else if(val.prop == "bumenzhiwei"){
          this.orderStr = "bumenzhiweipx";
        }else if(val.prop == "adress"){
          this.orderStr = "adresspx";
        }else if(val.prop == "statusname"){
          this.orderStr = "statuspx";
        }
        if(val.order == "descending"){
          this.orderType = "desc";
        }else{
          this.orderType = "asc";
        }
      }
      this.getProList();
    },
    handleEdit:function(index,row){
      this.$confirm('确认已处理该申请?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          id:row.id,
          status:1,
          mode:'update',
        }
        API_trial.setList(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
                message: "已处理成功",
                type: 'success'
            });
            this.getProList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch(err =>{
          this.$message.error('数据丢失，试试重新登陆！');
        });
      }).catch(err=>{});
    },
    handleView:function(index,row){
      this.viewVisible = true;
      this.viewForm = Object.assign({}, row);

    },
    handleSizeChange:function(val){
      this.pageSize = val;
      this.getProList();
    },
    handleCurrentChange:function(val){
      this.pageNumber = val;
      this.getProList();
    },
    indexMethod(index) {
      return (index+1)+(this.pageNumber-1)*this.pageSize;
    },

    getProList:function(val){
      if(this.value == "姓名"){
        this.souchs.usename = this.proName;
      }
      if(this.value == "电话"){
        this.souchs.phone = this.proName;
      }
      if(this.value == "QQ"){
        this.souchs.qq = this.proName;
      }
      if(this.value == "公司"){
        this.souchs.company = this.proName;
      }
      if(this.value == "部门职位"){
        this.souchs.bumenzhiwei = this.proName;
      }
      if(this.value == "地址"){
        this.souchs.adress = this.proName;
      }
      var flag = true;
      if(val == 1){
        this.pageNumber = 1;
        if(this.value){
          if(this.dynamicTags.length > 0){
            for(var i=0;i<this.dynamicTags.length;i++){
              if(this.value == this.dynamicTags[i]){
                flag = false;
              }
            }
          }
          if(flag){
            this.dynamicTags.push(this.value);
          }
        }
      }

      let param = {
        token:this.token,
        checkCode:this.checkCode,
        listType:'page',
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,

        name:this.souchs.usename,
        phone:this.souchs.phone,
        qq:this.souchs.qq,
        company:this.souchs.company,
        bumenzhiwei:this.souchs.bumenzhiwei,
        adress:this.souchs.adress,
        

        orderStr:this.orderStr,
        orderType:this.orderType,
        searchText: this.searchText

      }
      this.listLoading = true;
      API_trial.getList(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.proList = res.data.data.list;
          this.total = res.data.data.totalRow
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.listLoading = false;
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.listLoading = false;
      });
    },

    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
              this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
              this.id = arr2[1];
          }
        }
      }
    },
  },
  mounted(){
    this.getProList();
  },
  created(){
    this.getCookie();
  }
}
</script>
<style lang="scss">
.dnnCloud-applyTrial-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}

</style>
<style>
.el-table .warning-row {
  background: rgb(230, 244, 253);
}
.el-table .success-row {
  background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// ApplyTrial.vue?78c8dc48